import { withTheme } from "styled-components";
import DefaultTable, { Line } from "../../ui-library/CustomTable/DefaultTable";
import React from "react";
import { Dropdown } from "react-bootstrap";
import TableDropDown from "../../ui-library/TableDropDown/TableDropDown";

const CommentsTable = (props) => {
  const {
    getData,
    searchedParams,
    totalitems,
    comments,
    canViewScreenshot,
    openCommentImage,
    loading,
  } = props;

  const defaultProps = {
    headers: [
      { label: "Participant ID" },
      { label: "Comment" },
      { label: "Originator" },
      { label: "Options" },
    ],
    hasSearch: 1,
    haspagesizefilter: 1,
    haspagination: 1,
    searchedParams,
    totalitems,
    loading,
    getData,
  };

  const getDropDownItems = () => {
    const dropDownMenuItems = {
      VIEW_SCREENSHOT: {
        text: "View Screenshot",
        callBack: (comment) => openCommentImage(comment),
        id: 1,
        isDisabled: false,
        isVisible: canViewScreenshot,
      },
    };

    return Object.values(dropDownMenuItems);
  };

  return (
    <DefaultTable {...defaultProps}>
      {comments?.map((comment, index) => (
        <Line key={index}>
          <span>{comment.participantUgnxId}</span>
          <span>{comment.comment}</span>
          <span>{comment.originator}</span>
          <TableDropDown>
            {getDropDownItems()
              .filter((dropDownItem) => dropDownItem.isVisible)
              .map((item, index) => (
                <Dropdown.Item
                  key={index}
                  bsPrefix="dropdown-item"
                  disabled={item.isDisabled}
                  onClick={() => item.callBack(comment)}
                >
                  {item.text}
                </Dropdown.Item>
              ))}
          </TableDropDown>
        </Line>
      ))}
    </DefaultTable>
  );
};

export default withTheme(CommentsTable);
